export default "__VITE_ASSET__DAApGXxw__"